import { render, staticRenderFns } from "./AiChatWidget.vue?vue&type=template&id=1c15b6da&scoped=true&"
import script from "./AiChatWidget.vue?vue&type=script&lang=js&"
export * from "./AiChatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15b6da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c15b6da')) {
      api.createRecord('1c15b6da', component.options)
    } else {
      api.reload('1c15b6da', component.options)
    }
    module.hot.accept("./AiChatWidget.vue?vue&type=template&id=1c15b6da&scoped=true&", function () {
      api.rerender('1c15b6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ai/AiChatWidget.vue"
export default component.exports